export default () => ({
  show: false,
  edit: false,
  active: "default",
  formPosted: false,
  toggle(index) {
    this.show = index;
    Grebify.noScroll(!this.show);
  },
  hide() {
    this.show = false;
    Grebify.noScroll(!this.show);
  },
  submitPasswordReset(customerEmail) {
    const formData = new FormData();
    formData.append("email", customerEmail);

    fetch("/account/recover", {
      method: "POST",
      body: formData,
    }).then((response) => {
      //console.log(response);
      if (response.status === 429) {
        alert("something went wrong, please try again");
        return;
      }
      this.formPosted = true;
    });
  },
});
